<template>
    <transition-group name="notification" class="notifications-container">
        <div class="notification" :key="notification.key" v-for="(notification, index) in notifications" @click="removeNotification(index)">
            <div class="info">
                <img :src="imageUrl('check.svg')" />
                <div class="text">{{ notification.notification }}</div>
            </div>
        </div>
    </transition-group>
</template>

<script>
    import {EventBus} from "../../utilities/eventBus.js";
    import Mixins from "../../mixins/mixins";

    export default {
        data() {
            return {
                notifications: [],
                notificationIndex: 0
            };
        },
        mixins: [Mixins],
        methods: {
            cycleNotification (notification) {
                this.notifications.push({notification, key: this.notificationIndex});
                this.notificationIndex++;

                setTimeout(() => {
                    this.notifications.shift();
                }, 2000)
            },
            removeNotification(index) {
                this.notifications.splice(index, 1);
            }
        },
        created() {
            EventBus.$on('notification', this.cycleNotification);
        }
    };
</script>